import React from "react";

interface ProjectIconProps {
  color?: string;
}

const ProjectIcon: React.FC<ProjectIconProps> = ({ color }) => {
  return (
    <>
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2v11.733c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291H18m-.888-5.333h-3.556M10.89 5.556H5.556m9.778 3.555h-8"
          stroke="#fff"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export { ProjectIcon };

export const ActiveProjectIcon: React.FC<ProjectIconProps> = ({ color }) => {
  return (
    <>
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2v11.733c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291H18m-.888-5.333h-3.556M10.89 5.556H5.556m9.778 3.555h-8"
          stroke="#0D3C6D"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
